/*
 * Lemonade Training Oy, copy rights, all right reserved.
 * Router-free, so dialogs can name the gym's clock without importing ClockNote's Link.
 */
import { zoneCity } from "@lemonadetraining/contracts";
import type { DisplayZone } from "../../hooks/useDisplayZone";

/** "gym time (Helsinki)", for a sentence that names the clock. */
export const gymTimeLabel = (city: string | null): string =>
  city ? `gym time (${city})` : "gym time";

/** " Helsinki time" after a time in a toast, only while this device's clock differs at those instants. */
export const clockSuffix = (display: DisplayZone, instantsMs: readonly number[]): string => {
  if (!display.differs(instantsMs)) return "";
  if (display.mode === "gym") return ` ${display.city ?? "gym"} time`;
  const city = zoneCity(display.browserZone);
  return city ? ` ${city} time` : " your device's time";
};
